import Component from '@glimmer/component';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class GrowthVisitorsMonthlyLimitWarningBanner extends Component {
  @service basicVisitorsGating;
  @service router;

  get monthlyCount() {
    return this.basicVisitorsGating.monthlyCount ?? 0;
  }

  @action
  goToPlans() {
    this.router.transitionTo('billing.product-plans', 'visitors');
  }
}
